import ConfirmEmailSuccess from './ConfirmEmailSuccess';

export default ConfirmEmailSuccess;